import { CustomerTagSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Operator-defined customer tag templates.
 *
 *   tenants/{tid}/customerTags/{tagId}
 *
 * Read+write by owner|manager (firestore.rules). Voucher targeting and the
 * /customers tag picker both reference tag ids from this collection.
 */
export function customerTagsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/customerTags`,
    schema: CustomerTagSchema,
    name: `tenants/${tenantId}/customerTags`,
  });
}
